import { createSlice } from '@reduxjs/toolkit'
import {
    EstablishmentsType,
    GetEstablishmentsResponseType
} from '../../actions/types'
import {
    getEstablishments,
    createEstablishment,
    getCurrentEstablishment,
    getEstablishmentFromCompany,
} from '../../actions/establishmentsAction'

export interface IEstablishments {
    establishment: GetEstablishmentsResponseType
    establishmentsFromCurrentCompany: GetEstablishmentsResponseType
    currentEstablishment: EstablishmentsType
    error: any
    isLoading: boolean
    errorImage: any
}

const initialState: IEstablishments = {
    establishment: {
        establishments: [],
        totalCount: 0,
    },
    establishmentsFromCurrentCompany: {
        establishments: [],
        totalCount: 0,
    },

    currentEstablishment: {
        id: 0,
        name: '',
        city: '',
        address: '',
        size: '',
        description: '',
        images: [],
        company: {
            id: 0,
            name: '',
            role: '',
            city: '',
            address: '',
            contactFullName: '',
            contactPhone: '',
            email: '',
            inn: '',
            description: '',
            createdAt: '',
            isBlocked: false,
            employees: [],
            comments: [],
            images: [],
        },
        place: {
            id: 0,
            name: '',
            city: '',
            address: '',
            size: 0,
            description: '',
            color: '',
            images: [],
            files: [],
            createdAt: '',
            company: {
                id: 0,
                name: '',
                role: '',
                city: '',
                address: '',
                contactFullName: '',
                contactPhone: '',
                email: '',
                inn: '',
                description: '',
                createdAt: '',
                isBlocked: false,
                employees: [],
                comments: [],
                images: [],
            },
            isBlocked: false,
        }
    },
    isLoading: false,
    error: '',
    errorImage: '',
}

export const establishmentsSlice = createSlice({
    name: 'establishments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEstablishments.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getEstablishments.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = ''
            state.establishment = action.payload
        })
        builder.addCase(getEstablishments.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload
        })
        builder.addCase(getEstablishmentFromCompany.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getEstablishmentFromCompany.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = ''
            state.establishmentsFromCurrentCompany = action.payload
            state.establishment = action.payload
        })
        builder.addCase(getEstablishmentFromCompany.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload
        })
        builder.addCase(getCurrentEstablishment.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(getCurrentEstablishment.fulfilled, (state, action) => {
            state.isLoading = false
            state.error = ''
            state.currentEstablishment = action.payload
        })
        builder.addCase(getCurrentEstablishment.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload
        })
        builder.addCase(createEstablishment.pending, (state) => {
            state.error = ''
        })
        builder.addCase(createEstablishment.fulfilled, (state, action) => {
            state.error = ''
        })
        builder.addCase(createEstablishment.rejected, (state, action) => {
            state.error = action.payload
        })
    },
})

export const establishmentsReducer = establishmentsSlice.reducer
